<template>
  <v-container>
    <v-toolbar flat height="40">
      <v-toolbar-title>Broadcasts</v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items>
        <v-btn color="success" @click="newBroadcastModal">New Broadcast</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-data-table
      :items="broadcasts"
      :headers="headers"
    >
      <template v-slot:[`item.image_base64`]="{ item }">
        <img v-if="item.image_url" style="width: 70px;" :src="`${api_url}${item.image_url}`">
      </template>
      <template v-slot:[`item.actions`]="{ item }">
<!--        <v-btn icon color="primary" @click="editBroadcastModal(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>-->
        <v-btn icon @click="deleteBroadcastModal(item)">
          <v-icon color="error">mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog v-model="new_broadcast_group_modal" width="50%">
      <BroadcastGroupForm
        @close="new_broadcast_group_modal = !new_broadcast_group_modal"
      />
    </v-dialog>

    <v-dialog v-model="new_broadcast_modal" width="50%">
      <BroadcastForm
        @close="new_broadcast_modal = !new_broadcast_modal"
      />
    </v-dialog>

    <v-dialog v-model="edit_broadcast_modal" width="50%">
      <BroadcastForm
        @close="edit_broadcast_modal = !edit_broadcast_modal"
        :broadcast="edit_broadcast_obj"
        editing
      />
    </v-dialog>

    <v-dialog v-model="delete_broadcast_modal" width="50%">
      <v-card>
        Are sure you want to delete this table? ({{ delete_broadcast_obj ? delete_broadcast_obj.name  : ''}})
        <v-card-actions>
          <v-spacer/>
          <v-btn @click="delete_broadcast_modal = !delete_broadcast_modal">Cancel</v-btn>
          <v-btn
              :loading="isLoading1"
              color="error"
              @click="deleteBroadcast(delete_broadcast_obj)">Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import BroadcastForm from "@/components/forms/BroadcastForm";
import { getBaseUrl } from "@/services/helper"
import BroadcastGroupForm from "@/views/broadcast/BroadcastGroupForm.vue";
let i = 0

export default {
  name: "BroadcastsView",
  components: {BroadcastGroupForm, BroadcastForm },
  data() {
    return {
      headers: [
        { text: 'Content', value: 'content' },
        { text: 'Created By', value: 'created_by.email' },
        { text: 'Image', value: 'image_base64' },
        { text: 'Date Created', value: 'date_created' },
        { text: 'Actions', value: 'actions' },
      ],
      new_broadcast_group_modal: false,
      new_broadcast_modal: false,
      edit_broadcast_modal: false,
      delete_broadcast_modal: false,
      new_broadcast_obj: {},
      edit_broadcast_obj: {},
      delete_broadcast_obj: {},
      api_url: getBaseUrl().substring(0, getBaseUrl().length - 8)
    }
  },
  methods: {
    newBroadcastModal() {
      this.new_broadcast_obj = {}
      this.new_broadcast_modal = !this.new_broadcast_modal
    },
    editBroadcastModal(item) {
      this.edit_broadcast_obj = item
      this.edit_broadcast_modal = !this.edit_broadcast_modal
    },
    deleteBroadcastModal(item) {
      this.delete_broadcast_obj = item
      this.delete_broadcast_modal = !this.delete_broadcast_modal
    },
    async deleteBroadcast(item) {
      await this.$store.dispatch('DELETE_BROADCAST', { _id: item._id })
      this.delete_broadcast_modal = !this.delete_broadcast_modal
    },
    getImage(base64) {
      fetch(base64)
      .then(res => res.blob())
      .then(res => {
        i++
        if (this.broadcasts[i]) {
          this.broadcasts[i].file_url = URL.createObjectURL(res)
        }
      })
    }
  },
  computed: {
    broadcasts() {
      return this.$store.getters.broadcasts
    },
    isLoading1() {
      return this.$store.getters.isLoading1
    }
  },
  watch: {
    broadcasts(v) {
      return v
    },
    isLoading1(v) {
      return v
    }
  },
  created() {
    this.$store.dispatch('GET_BROADCASTS')
  }
}
</script>

<style scoped>

</style>